module.exports = __webpack_public_path__ + "static/img/3.6d5b08a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/eng/3.png
// module id = Iu/c
// module chunks = 0